import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { DOM } from '@antv/l7-utils';
import Control, { PositionType } from './BaseControl';

var Logo = function (_Control) {
  _inherits(Logo, _Control);

  var _super = _createSuper(Logo);

  function Logo() {
    _classCallCheck(this, Logo);

    return _super.apply(this, arguments);
  }

  _createClass(Logo, [{
    key: "getDefault",
    value: function getDefault() {
      return {
        position: PositionType.BOTTOMLEFT,
        name: 'logo'
      };
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      var className = 'l7-control-logo';
      var container = DOM.create('div', className);
      var anchor = DOM.create('a', 'l7-ctrl-logo');
      anchor.target = '_blank';
      anchor.rel = 'noopener nofollow';
      anchor.href = 'https://antv.alipay.com/l7';
      anchor.setAttribute('aria-label', 'AntV logo');
      anchor.setAttribute('rel', 'noopener nofollow');
      container.appendChild(anchor);
      return container;
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      return null;
    }
  }]);

  return Logo;
}(Control);

export { Logo as default };
//# sourceMappingURL=logo.js.map